import React, { createContext, useContext, useMemo } from "react";
import { ApiClient } from "../../service/api-client";
import { useRecoilValue } from "recoil";
import { tokenAtom } from "../../store";

const DataAPIContext = createContext<ApiClient | null>(null);

export const DataAPIProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const token = useRecoilValue(tokenAtom);

  const apiClient = useMemo(() => {
    const client = new ApiClient(process.env.REACT_APP_BASE_URL!);
    if (token) {
      client.setAuthToken(token);
    }
    return client;
  }, [token]);

  return (
    <DataAPIContext.Provider value={apiClient}>
      {children}
    </DataAPIContext.Provider>
  );
};

export const useDataAPI = () => {
  const context = useContext(DataAPIContext);
  if (!context) {
    throw new Error("useDataAPI must be used within a DataAPIProvider");
  }
  return context;
};
